import React from 'react';

const LanguageSwitcher = ({ toggleLanguage }) => {
    return (
        <select onChange={toggleLanguage} name="languages" id="languages">
            <option value="pt-BR">🇧🇷</option>
            <option value="en-US">🇺🇸</option>
        </select>
    );
}

export default LanguageSwitcher;